import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Status} from '../../master-data/master-data.model';
import {MasterDataService} from '../../master-data/master-data-service';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class StatusesResolve {
  private masterDataService = inject(MasterDataService);


  getStatuses(): Observable<Status[]> {
    return this.masterDataService.getStatuses();
  }
}

export const statusesResolver: ResolveFn<Status[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(StatusesResolve).getStatuses();
  };

